import { AngularServices, AppServices } from "../helpers/config_keys";
import { IRequestResult } from "../schemas/structure";
let _: UnderscoreStatic = require("underscore")

class DashboardCtrl {
    loading: boolean;
    stats: any;
    loanRequestChart = {}

    static $inject = [AngularServices.Q, AngularServices.Http, AngularServices.State, AppServices.BaseApi];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private $state: angular.ui.IStateService,
        private baseUrl: string) {
        this.loadStats()
        this.loadCharts()
    }

    private loadStats() {
        this.loading = true
        this.$http.get(`${this.baseUrl}/stats/general`).then((res: IRequestResult<any>) => {
            this.loading = false
            if (res.success) { this.stats = res.data }
        })
    }

    private loadCharts() {
        this.loading = true
        this.$http.get(`${this.baseUrl}/stats/msghistory`).then((res: IRequestResult<any>) => {
            this.loading = false
            if (res.success) { this.setUpCharts(res.data) }
        })
    }

    private setUpCharts(data: any) {
        this.loanRequestChart = {
            labels: _.pluck(data, 'month'),
            series: ['SMS', 'Email'],
            data: [_.pluck(data, 'sms'), _.pluck(data, 'email')],
            options: {
                legend: {
                    display: true,
                    position: 'bottom'
                }
            }

        }


    }

}

export { DashboardCtrl }


// WEBPACK FOOTER //
// ./app/main/dashboard_ctrl.ts